import {
  GetSourceFromFieldsProps,
  GetSourceFromFieldsResult,
  getAssetProps,
} from './';

export function getSourceFromFields(
  props: GetSourceFromFieldsProps,
): GetSourceFromFieldsResult {
  const { asset } = props;
  if (asset === null)
    return {
      assetType: 'void',
    };
  if (asset.videoUrl && asset.image) {
    return {
      ...asset,
      assetType: 'videoWithPlaceholder',
      assetOrigin: 'external',
      url: asset.videoUrl,
    };
  }
  if (asset.image)
    return {
      ...asset,
      assetType: 'image',
      assetOrigin: 'contentful',
      url: getAssetProps(asset.image).url,
    };
  if (asset.imageUrl)
    return {
      ...asset,
      assetType: 'image',
      assetOrigin: 'external',
      url: asset.imageUrl,
    };
  if (asset.video)
    return {
      ...asset,
      assetType: 'video',
      assetOrigin: 'contentful',
      url: getAssetProps(asset.video).url,
    };
  if (asset.videoUrl)
    return {
      ...asset,
      assetType: 'video',
      assetOrigin: 'external',
      url: asset.videoUrl,
    };
  return {
    assetType: 'void',
  };
}
